import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import UserContext from "../../context/context";
import { message } from "antd";
import { useHistory } from "react-router-dom";
import AddQuestionBankModal from "../../components/CareerQuizComponents/addQuestionBankModal";
import {DOMAIN} from "../../env";

function CareerQuiz() {
	const user = useContext(UserContext);
	const history = useHistory();
	const [data, setData] = useState();
	const [filter, setFilter] = useState({
		name: "",
	});

	const dataFilter = function (dataArr, filterArr) {
		let data = dataArr;
		if (filterArr.name)
			data = data && data.filter((i) => i.name.toLowerCase().includes(filterArr.name.toLowerCase()) );
		return data;
	};

	const filteredData = dataFilter(data, filter);

	useEffect(() => {
		const fetchApiData = async () => {
			try {
				if (
					!["Developer", "Marketing", "HumanResources", "Admin"].includes(
						user.user.user_role
					)
				) {
					message.error({
						content: `Unauthorized!`,
						className: "text-center",
						duration: 2,
					});
					history.push("/");
				} else {
					await axios
						.get(
							`${DOMAIN}/api/careers_quiz/get_all_question_banks`,
							{
								headers: {
									"jwt-token": user.jwtToken,
								},
							}
						)
						.then((res) => {
							setData(res.data.data);
						});
				}
			} catch (Error) {}
		};
		fetchApiData();
	}, [history, user.jwtToken, user.user.user_role]);
	
	const renderQuestionBanks = () => {
		const cards = filteredData?.map((elem, index) => {
			return (
				<Link to={`/careerQuiz/questionBank/questions/${elem._id}`} key={index} className="group rounded-2xl border-2 border-green-11 shadow-lg transition-all duration-500 hover:bg-green-11 bg-zinc-100">
					<div className="z-10 px-4 min-h-[8rem] text-center flex items-center justify-center h-full">
						<p className=" font-poppins text-2xl font-bold text-grey-1 transition-all duration-500 group-hover:text-white">
							{elem.name}
						</p>
					</div>
				</Link>
			);
		});

		if (cards) return cards;
		else {
			return [...new Array(12)].map((item, index) => (
				<div className="relative h-32 w-full rounded-2xl bg-gray-300 animate-pulse border-2 border-zinc-400" key={index}>
					<div className="absolute flex h-full w-full items-center justify-center">
						<div role="status">
							<svg aria-hidden="true" className="h-14 w-14 animate-spin fill-gray-400 text-gray-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
							<span className="sr-only">Loading...</span>
						</div>
					</div>
				</div>
			));
		}
	};

	return (
		<>
			<Helmet>
				<title>Career Quizzes</title>
			</Helmet>
			<div className="flex flex-col items-center justify-between bg-grey-1 p-5 lg:flex-row">
				<p className=" mb-0 text-center font-poppins text-xl font-bold text-white md:text-2xl lg:text-left">
					Career Quizzes
				</p>
			</div>
			<div className="p-3">
				<div className="flex flex-col gap-5 pb-5 pt-2 md:flex-row">
					<AddQuestionBankModal />
					<div className="relative md:ml-auto">
						<div className="flex max-h-[3rem] w-full flex-row items-center justify-center gap-3 rounded-2xl bg-grey-1 py-2 pl-4 pr-2 md:w-48">
							<div className="">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className=" h-5 w-5 fill-current text-white"
									viewBox="0 0 24 24"
								>
									<path d="M23.822 20.88l-6.353-6.354c.93-1.465 1.467-3.2 1.467-5.059.001-5.219-4.247-9.467-9.468-9.467s-9.468 4.248-9.468 9.468c0 5.221 4.247 9.469 9.468 9.469 1.768 0 3.421-.487 4.839-1.333l6.396 6.396 3.119-3.12zm-20.294-11.412c0-3.273 2.665-5.938 5.939-5.938 3.275 0 5.94 2.664 5.94 5.938 0 3.275-2.665 5.939-5.94 5.939-3.274 0-5.939-2.664-5.939-5.939z" />
								</svg>
							</div>
							<input
								type="text"
								placeholder="Search by name"
								onChange={(e) => setFilter({ ...filter, name: e.target.value })}
								className={`h-8 w-full appearance-none rounded-lg bg-grey-13 py-2 px-3 leading-tight text-gray-700 focus:border-transparent focus:outline-none`}
							/>
						</div>
					</div>
				</div>
				<div className="grid grid-cols-1 gap-5 pt-5 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
					{renderQuestionBanks()}
				</div>
			</div>
		</>
	);
}

export default CareerQuiz;
